import SearchBar from "../../components/SearchBar";
import MainContainer from "../../layout/MainContainer";
import { useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Filter } from "@mui/icons-material";
import FilterMenu from "../../components/filterMenu";
const AddMember = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const members = Array.from({ length: 10 }, (_, i) => `Member ${i + 1}`);
  const rows = [
    {
      name: "Madelyn Dias",
      email: "abdul@sample.com",
      membershipType: "Single",
      membershipStatus: "Paid",
      paymentStatus: "Paid",
      createdDate: "18 – June – 2025 | 6:00PM",
      avatar: "", // optional avatar path
    },
    {
      name: "Madelyn Dias",
      email: "abdul@sample.com",
      membershipType: "Duo",
      membershipStatus: "Complimentary",
      paymentStatus: "Pending",
      createdDate: "18 – June – 2025 | 6:00PM",
    },
    // more records...
  ];
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Select Members</h1>
          </div>
          <div className="right_s">
            <SearchBar searchTerm={""} placeholder={"Search..."} />
            <FilterMenu />
            <Button
              onClick={() => navigate("/manage-cms/viewGroup")}
              className="btn btn_primary"
            >
              Back
            </Button>
          </div>
        </div>
        <div className="cards table_cards">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th><Checkbox /></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Membership Type</th>
                  <th>Membership Status</th>
                  <th>Payment Status</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td>
                      <Checkbox />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={
                          row.avatar || "/static/images/user_placeholder.png"
                        }
                        alt={row.name}
                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                      />
                      {row.name}
                    </td>
                    <td>{row.email}</td>
                    <td>{row.membershipType}</td>
                    <td>{row.membershipStatus}</td>
                    <td>{row.paymentStatus}</td>
                    <td>{row.createdDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt_30">
          <Button className="btn btn_primary">Add</Button>
        </div>{" "}
      </MainContainer >
    </>
  );
};
export default AddMember;
